enum CategoryTag {
    IMPORTANT = "important",
    REPONSE_ATTENDUE = "reponse_attendue",
    RAPPEL = "rappel",
    INFORMATIF = "informatif",
    NEWSLETTER = "newsletter",
    SUSPECT = "suspect",
    AUTRE = "autre",
}

export const categoryTagColors = {
    [CategoryTag.IMPORTANT]: "#BE185D",
    [CategoryTag.REPONSE_ATTENDUE]: "#A21CAF",
    [CategoryTag.RAPPEL]: "#D97706",
    [CategoryTag.INFORMATIF]: "#3D4CEE",
    [CategoryTag.NEWSLETTER]: "#178A84",
    [CategoryTag.SUSPECT]: "#994A35",
    [CategoryTag.AUTRE]: "#9072B5",
};

export default CategoryTag;
